/**
 * @generated SignedSource<<eb2efe93e60403f848a71a1d1fc042ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeEOYMessaging_tradeFirmRewards$data = {
  readonly currentProgram: {
    readonly programInfo: {
      readonly code: string | null;
    } | null;
  } | null;
  readonly currentYearPoints: number | null;
  readonly " $fragmentType": "TradeEOYMessaging_tradeFirmRewards";
};
export type TradeEOYMessaging_tradeFirmRewards$key = {
  readonly " $data"?: TradeEOYMessaging_tradeFirmRewards$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeEOYMessaging_tradeFirmRewards">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "TradeEOYMessaging_tradeFirmRewards"
};

(node as any).hash = "c59bcd3ad6a0cb1a6d298774635ca06f";

export default node;
